import React, { useEffect, useState,useContext } from "react";
import PropTypes from "prop-types";
import AuthService from "../../service/AuthService";
import appStyles from "../../styles/appStyles";
import { customStyles } from "../../styles/tableStyle";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { UploadFileOutlined } from "@mui/icons-material";
import Connection from "./Connection";
import Config from "./Config";
import Disclaimer from "../other/Disclaimer";
import { useFetcher } from "react-router-dom";
import { AuthContext } from "../../AuthProvider";

const { Card, CardHeader, CardContent, CardActions, Button, LinearProgress, Divider,
  Typography, Box, RadioGroup, Radio, FormControlLabel, FormControl, InputLabel, Select, MenuItem,
  ToggleButtonGroup, ToggleButton, IconButton, Tooltip,
  Icon,
  Paper } = require("@mui/material")

const { commons, util } = require("../../commons")
const { SnackBarWidget } = require("../../Widget");


export default function RTLActions(props) {
  const [selectedRadio, setSelectedRadio] = useState('')
  const [toggleAction, setToggleAction] = useState('configFile')
  const { setRegisterMapData, setType, actionType } = useContext(AuthContext);

  useEffect(() => {
    let projectId = localStorage.getItem("projectId");
    setRegisterMapData(projectId + "_" + props.type.toLowerCase(), [])
    setType(props.type.toLowerCase())

  }, [])


  const handleToggle = (e) => {
    setToggleAction(e.target.value)
  }



  return (
    <Box sx={{
      alignContent: 'center', width: '96%',
    }}>
      {commons.detectInternet()}
      <Paper elevation={1}>
        <ToggleButtonGroup
          color="primary"
          value={toggleAction}
          exclusive
          onChange={(e) => handleToggle(e)}
          style={{flex: 1, padding: 5 , alignContent: 'center'}}
        >
          <ToggleButton value="configFile" style={{}}><CloudUploadIcon style={{ padding: 1 }}></CloudUploadIcon>&nbsp;Subsystem Config </ToggleButton>
          <ToggleButton value="connectionFile" style={{}}><CloudUploadIcon style={{ padding: 1 }}></CloudUploadIcon>&nbsp;Subsystem Connections</ToggleButton>
        </ToggleButtonGroup>

        {toggleAction === "configFile" ? <Config type={props.type} loadLogs={props.loadLogs} /> :
          <Connection type={props.type} loadLogs={props.loadLogs} />}
      </Paper>
    </Box>
  );

}


